import { createAsyncActionTypes, createActionType } from '../../helpers';

const domain = 'users';

const fetchMoreUsers = createAsyncActionTypes(domain, 'fetchMoreUsers');
const searchUsers = createAsyncActionTypes(domain, 'searchUsers');
const deleteUser = createAsyncActionTypes(domain, 'deleteUser');
const sendReinvite = createAsyncActionTypes(domain, 'sendReinvite');
const getUserById = createAsyncActionTypes(domain, 'getUserById');
const getUsers = createAsyncActionTypes(domain, 'getUsers');
const getUsersForExcel = createAsyncActionTypes(domain, 'getUsersForExcel');
const updateUser = createAsyncActionTypes(domain, 'updateUser');
const addUser = createAsyncActionTypes(domain, 'addUser');
const resetUser = createActionType(domain, 'resetUser');
const getWritersMatch = createAsyncActionTypes(domain, 'getWritersMatch');
const getOfflineWritersMatch = createAsyncActionTypes(domain, 'getOfflineWritersMatch');
const addWriterToShortlist = createAsyncActionTypes(domain, 'addWriterToShortlist');
const removeWriterFromShortlist = createAsyncActionTypes(domain, 'removeWriterFromShortlist');
const getUserWithMiscData = createAsyncActionTypes(domain, 'getUserWithMiscData');
const toggleArchivingUser = createAsyncActionTypes(domain, 'toggleArchivingUser');
const removeAvatar = createAsyncActionTypes(domain, 'removeAvatar');
const addAvatarPhoto = createAsyncActionTypes(domain, 'addAvatarPhoto');
const getExcelWritersMatch = createAsyncActionTypes(domain, 'getExcelWritersMatch');
const getExcelOfflineWritersMatch = createAsyncActionTypes(domain, 'getExcelOfflineWritersMatch');
const removeUnsavedUserAvatar = createAsyncActionTypes(domain, 'removeUnsavedUserAvatar');
const setupPassword = createAsyncActionTypes(domain, 'setupPassword');
const getUserByToken = createAsyncActionTypes(domain, 'getUserByToken');
const updateHubspotProjectsCount = createAsyncActionTypes(domain, 'updateHubspotProjectsCount');
const updateWritersProjectCount = createAsyncActionTypes(domain, 'updateWritersProjectCount');
const updateWritersDBSScreened = createAsyncActionTypes(domain, 'updateWritersDBSScreened');

export default {
  fetchMoreUsers,
  searchUsers,
  deleteUser,
  sendReinvite,
  getUserById,
  getUsers,
  getUsersForExcel,
  updateUser,
  addUser,
  resetUser,
  getWritersMatch,
  getOfflineWritersMatch,
  addWriterToShortlist,
  removeWriterFromShortlist,
  getUserWithMiscData,
  toggleArchivingUser,
  removeAvatar,
  addAvatarPhoto,
  getExcelWritersMatch,
  getExcelOfflineWritersMatch,
  removeUnsavedUserAvatar,
  setupPassword,
  getUserByToken,
  updateHubspotProjectsCount,
  updateWritersProjectCount,
  updateWritersDBSScreened,
};
